import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";
import logo from "../images/logo.png"; // ✅ Transparent PNG or SVG recommended

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About Us" },
    { path: "/services", label: "Services" },
    { path: "/projects", label: "Projects" },
    { path: "/contact", label: "Contact" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <nav className="max-w-7xl mx-auto px-6 py-2">
        <div className="flex items-center justify-between">
          {/* ✅ Logo */}
          <Link
            to="/"
            className="flex items-center gap-2 hover:opacity-90 transition-opacity"
            onClick={() => setIsMenuOpen(false)}
          >
            <img
              src={logo}
              alt="Yours Energy Solutions Logo"
              className="w-28 md:w-32 h-auto object-contain"
            />
          </Link>

          {/* ✅ Desktop Menu */}
          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-medium transition-colors duration-300 hover:text-[#4CAF50] ${
                  isActive(link.path)
                    ? "text-[#4CAF50] font-semibold"
                    : "text-gray-700"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/contact">
              <Button className="bg-[#FFC107] hover:bg-[#FFD54F] text-black font-semibold transition-all duration-300 hover:shadow-lg">
                Get Quote
              </Button>
            </Link>
          </div>

          {/* ✅ Mobile Hamburger Button */}
          <button
            className="md:hidden text-gray-700 hover:text-[#4CAF50] transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* ✅ Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden flex flex-col gap-4 mt-3 bg-white border-t border-gray-100 py-4 px-4 shadow-md rounded-lg animate-slide-down">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block text-base font-medium transition-colors duration-200 hover:text-[#4CAF50] ${
                  isActive(link.path)
                    ? "text-[#4CAF50] font-semibold"
                    : "text-gray-700"
                }`}
                onClick={() => setIsMenuOpen(false)} // ✅ close menu on click
              >
                {link.label}
              </Link>
            ))}

            <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
              <Button className="w-full bg-[#FFC107] hover:bg-[#FFD54F] text-black font-semibold transition-all duration-300 hover:shadow-md">
                Get Quote
              </Button>
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
